export default {
  title: 'Verkoopteamrapport',
  fields: {
    name: 'Naam',
    area: 'Gebied',
    signed: 'Ondertekend',
    live: 'Live',
  },
  buttons: {
    download_report: 'Rapport downloaden',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt, vernieuw de pagina',
  },
};
